import { IResult } from '@hitiq/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
// import { translator } from '../../../../translations/translation.config';

export const deleteAuthThunk = createAsyncThunk(
  'auth/deleteAuth',
  async (
    payload: {
      authenticator: any;
      amplifyDataStore: any;
      store: any;
    },
    thunkAPI,
  ): Promise<any> => {
    const { authenticator, amplifyDataStore, store } = payload;
    return authenticator
      .deleteUserAsync()
      .then((result: IResult) => {
        if (result.success) {
          store.dispatch({
            type: 'RESET_STORE',
          });
        }
      })
      .catch((error: any) => {
        amplifyDataStore.startSync();
        return thunkAPI.rejectWithValue({
          heading: 'unable to delete account', // translator.translateText('settings:unableToDeleteAccount'),
          message: 'unable to delete account mesage', // translator.translateText(
          // 'settings:unableToDeleteAccountMessage',
          // ),
          severity: 'error',
          id: uuidv4(),
        });
      });
  },
);
